<template>
    <div class="p-1">
        <h1 class="text-xs text-center w-full font-bold">第三方信息共享清单</h1>
        <h2 class="text-justify font-bold mb-2">您授权同意我们可能委托授权合作伙伴为您提供某些服务或代表我们履行职能，我们仅会出于本隐私信息保护政策声明的合法、正当、必要、特定、明确的目的共享您的信息，授权合作伙伴只能接触到为其履行职责所需信息，且不得将此信息用于其他任何目的。</h2>

        <div class="box mb-3">
            <p>（1）友盟+SDK（com.umeng）</p>
            <p><span>第三方公司名称：</span>友盟同欣（北京）科技有限公司</p>
            <p><span>共享类型：</span>内嵌SDK</p>
            <p><span>共享信息：</span>友盟+SDK采集唯一设备识别码、获取设备序列号（如IMEI、Android_ID、IDFA、OPENUDID、GUID、IP地址、SIM卡 IMSI、MAC、OAID、ICCID 信息）、位置信息、网络信息、获取应用列表</p>
            <p><span>使用目的：</span>对用户进行唯一标识</p>
            <p><span>使用场景：</span>统计用户新增等数据、剔除作弊设备</p>
            <p><span>共享方式：</span>（外部）接口共享</p>
            <p><span>第三方隐私链接：</span><a target="_blank" href="https://www.umeng.com/page/policy">https://www.umeng.com/page/policy</a></p>
        </div>


        <div class="box mb-3">
            <p>（2）阿里云数据分析 SDK</p>
            <p><span>第三方公司名称：</span>阿里云计算有限公司</p>
            <p><span>共享类型：</span>内嵌SDK</p>
            <p><span>共享信息：</span>设备基础信息：唯一设备识别码 IMEI、IMSI 信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本；获取设备硬件序列号、获取Android ID、获取 MAC 地址。</p>
            <p><span>使用目的：</span>对用户进行唯一标识</p>
            <p><span>使用场景：</span>提供数据管理同步、统计分析的功能服务</p>
            <p><span>共享方式：</span>（外部）接口共享</p>
            <p><span>第三方隐私链接：</span><a target="_blank" href="https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202112131013_69952.html?spm=a2c4g.11186623.0.0.f5bc28e6m8gSq9">https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202112131013_69952.html?spm=a2c4g.11186623.0.0.f5bc28e6m8gSq9</a></p>

        </div>
        <div class="box mb-3">
            <p>（3）优量汇SDK</p>
            <p><span>第三方公司名称：</span>深圳市腾讯计算机系统有限公司</p>
            <p><span>共享类型：</span>内嵌SDK</p>
            <p><span>共享信息：</span>唯一设备识别码（IMEI/Android_ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息）、联网状态信息、获取位置信息；无线网SSID名称、WiFi路由器MAC地址（BSSID）、设备的MAC地址；设备标识符（如IMEI、IMSI、ICCID、GAID（仅GMS服务）、MEID、设备序列号build_serial，具体字段因软硬件版本不同而存在差异）；设备标识符（如IDFA，具体字段因软硬件版本不同而存在差异）；获取运行中进程信息、获取应用安装列表；精确位置信息、粗略位置信息；获取设备硬件序列号、获取Android ID、获取 MAC 地址、设备IP地址。</p>
            <p><span>使用目的：</span>广告投放及监测归因、反作弊、统计分析、减少App崩溃、提供可靠稳定的服务</p>
            <p><span>使用场景：</span>广告投放</p>
            <p><span>共享方式：</span>（外部）接口共享</p>
            <p><span>第三方隐私链接：</span><a target="_blank" href="https://e.qq.com/dev/help_detail.html?cid=2005&pid=5983">https://e.qq.com/dev/help_detail.html?cid=2005&pid=5983</a></p>
        </div>
        <div class="box mb-3">
            <p>（4）穿山甲 SDK（com.bytedance）</p>
            <p><span>第三方公司名称：</span>北京巨量引擎网络技术有限公司</p>
            <p><span>共享类型：</span>内嵌SDK</p>
            <p><span>共享信息：</span>唯一设备识别码（IMEI/Android_ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息）、联网状态信息、获取位置信息；无线网SSID名称、WiFi路由器MAC地址（BSSID）、设备的MAC地址；设备标识符（如IMEI、IMSI、ICCID、GAID（仅GMS服务）、MEID、设备序列号build_serial，具体字段因软硬件版本不同而存在差异）；设备标识符（如IDFA，具体字段因软硬件版本不同而存在差异）；应用信息：获取运行中进程信息、获取应用安装列表；位置信息：精确位置信息、粗略位置信息；获取设备硬件序列号、获取Android ID、获取 MAC 地址、设备IP地址。</p>
            <p><span>使用目的：</span>广告投放及监测归因、反作弊、统计分析、减少App崩溃、提供可靠稳定的服务</p>
            <p><span>使用场景：</span>广告投放</p>
            <p><span>共享方式：</span>（外部）接口共享</p>
            <p><span>第三方隐私链接：</span><a target="_blank" href="https://www.csjplatform.com/privacy">https://www.csjplatform.com/privacy</a></p>
        </div>
        <div class="box mb-3">
            <p>（5）京准通 SDK</p>
            <p><span>第三方公司名称：</span>北京京东世纪贸易有限公司</p>
            <p><span>共享类型：</span>内嵌SDK</p>
            <p><span>共享信息：</span>唯一设备识别码（IMEI/Android_ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息）、联网状态信息、获取位置信息、获取运行中进程信息、获取应用安装列表；获取设备硬件序列号、获取Android ID、获取 MAC 地址。</p>
            <p><span>使用目的：</span>广告投放及监测归因、反作弊、统计分析、减少App崩溃、提供可靠稳定的服务</p>
            <p><span>使用场景：</span>广告投放</p>
            <p><span>共享方式：</span>（外部）接口共享</p>
            <p><span>第三方隐私链接：</span><a target="_blank" href="https://jzt.jd.com/gw/agreement">https://jzt.jd.com/gw/agreement</a></p>
        </div>
        <div class="box mb-3">
            <p>（6）蒂烨 SDK</p>
            <p><span>第三方公司名称：</span>蒂烨大数据科技（广州）有限公司</p>
            <p><span>共享类型：</span>内嵌SDK</p>
            <p><span>共享信息：</span>唯一设备识别码（IMEI/Android_ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息）、联网状态信息、获取位置信息、获取运行中进程信息、获取应用安装列表；获取设备硬件序列号、获取Android ID、获取 MAC 地址。</p>
            <p><span>使用目的：</span>广告投放及监测归因、反作弊、统计分析、减少App崩溃、提供可靠稳定的服务</p>
            <p><span>使用场景：</span>广告投放</p>
            <p><span>共享方式：</span>（外部）接口共享</p>
            <p><span>第三方隐私链接：</span><a target="_blank" href="https://bxr.im/activity/html/m20200803Agreements/html/dierdodo_policy.html">https://bxr.im/activity/html/m20200803Agreements/html/dierdodo_policy.html</a></p>
        </div>
        <div class="box mb-3">
            <p>（7）MMA 中国广告监测通用SDK</p>
            <p><span>第三方公司名称：</span>上海亦拓广告有限公司</p>
            <p><span>共享类型：</span>内嵌SDK</p>
            <p><span>共享信息：</span>唯一设备识别码（IMEI/Android_ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息）、联网状态信息、获取位置信息、获取运行中进程信息、获取应用安装列表；获取设备硬件序列号、获取Android ID、获取 MAC 地址。</p>
            <p><span>使用目的：</span>广告投放及监测归因、反作弊、统计分析、减少App崩溃、提供可靠稳定的服务</p>
            <p><span>使用场景：</span>广告投放</p>
            <p><span>共享方式：</span>（外部）接口共享</p>
            <p><span>第三方隐私链接：</span><a target="_blank" href="https://mmachina.cn/sdk-privacy">https://mmachina.cn/sdk-privacy/</a></p>
        </div>
        <div class="box mb-3">
            <p>（8）创智汇聚 SDK（Sigmob SDK）</p>
            <p><span>第三方公司名称：</span>北京创智汇聚科技有限公司</p>
            <p><span>共享类型：</span>内嵌SDK</p>
            <p><span>共享信息：</span>唯一设备识别码（IMEI/Android_ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息）、联网状态信息、获取位置信息、获取运行中进程信息、获取应用安装列表；获取设备硬件序列号、获取Android ID、获取 MAC 地址。</p>
            <p><span>使用目的：</span>广告投放及监测归因、反作弊、统计分析、减少App崩溃、提供可靠稳定的服务</p>
            <p><span>使用场景：</span>广告投放</p>
            <p><span>共享方式：</span>（外部）接口共享</p>
            <p><span>第三方隐私链接：</span><a target="_blank" href="https://newdocs.toponad.com/docs/1Mn1B7">https://newdocs.toponad.com/docs/1Mn1B7</a></p>
        </div>
        <div class="box mb-3">
            <p>（9）快手联盟 SDK</p>
            <p><span>第三方公司名称：</span>北京快手广告有限公司</p>
            <p><span>共享类型：</span>内嵌SDK</p>
            <p><span>共享信息：</span>唯一设备识别码（IMEI/Android_ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息）、联网状态信息、获取位置信息、获取运行中进程信息、获取应用安装列表；获取设备硬件序列号、获取Android ID、获取 MAC 地址。</p>
            <p><span>使用目的：</span>广告投放及监测归因、反作弊、统计分析、减少App崩溃、提供可靠稳定的服务</p>
            <p><span>使用场景：</span>广告投放</p>
            <p><span>共享方式：</span>（外部）接口共享</p>
            <p><span>第三方隐私链接：</span><a target="_blank" href="https://u.kuaishou.com/home/detail/1220">https://u.kuaishou.com/home/detail/1220</a></p>
        </div>
        <div class="box mb-3">
            <p>（10）小米推送 SDK（ Milink SDK）</p>
            <p><span>第三方公司名称：</span>北京小米科技有限公司</p>
            <p><span>共享类型：</span>内嵌SDK</p>
            <p><span>共享信息：</span>唯一设备识别码（IMEI/Android_ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息）、联网状态信息、获取位置信息、获取运行中进程信息、获取应用安装列表；获取设备硬件序列号、获取Android ID、获取 MAC 地址。</p>
            <p><span>使用目的：</span>实现消息推送服务</p>
            <p><span>使用场景：</span>消息推送</p>
            <p><span>共享方式：</span>（外部）接口共享</p>
            <p><span>第三方隐私链接：</span><a target="_blank" href="https://dev.mi.com/distribute/doc/details?pId=1534">https://dev.mi.com/distribute/doc/details?pId=1534</a></p>
        </div>
        <div class="box mb-3">
            <p>（11）魅族推送 SDK</p>
            <p><span>第三方公司名称：</span>珠海星纪魅族信息技术有限公司</p>
            <p><span>共享类型：</span>内嵌SDK</p>
            <p><span>共享信息：</span>唯一设备识别码（IMEI/Android_ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息）、联网状态信息、获取位置信息、获取运行中进程信息、获取应用安装列表；获取设备硬件序列号、获取Android ID、获取 MAC 地址。</p>
            <p><span>使用目的：</span>实现消息推送服务</p>
            <p><span>使用场景：</span>消息推送</p>
            <p><span>共享方式：</span>（外部）接口共享</p>
            <p><span>第三方隐私链接：</span><a target="_blank" href="https://open.flyme.cn/docs?id=202">https://open.flyme.cn/docs?id=202</a></p>
        </div>
        <div class="box mb-3">
            <p>（12）华为推送 SDK</p>
            <p><span>第三方公司名称：</span>华为软件技术有限公司</p>
            <p><span>共享类型：</span>内嵌SDK</p>
            <p><span>共享信息：</span>唯一设备识别码（IMEI/Android_ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息）、联网状态信息、获取位置信息、获取运行中进程信息、获取应用安装列表；获取设备硬件序列号、获取Android ID、获取 MAC 地址。</p>
            <p><span>使用目的：</span>实现消息推送服务</p>
            <p><span>使用场景：</span>消息推送</p>
            <p><span>共享方式：</span>（外部）接口共享</p>
            <p><span>第三方隐私链接：</span><a target="_blank" href="https://developer.huawei.com/consumer/cn/doc/HMSCore-Guides/sdk-data-security-0000001050042177">https://developer.huawei.com/consumer/cn/doc/HMSCore-Guides/sdk-data-security-0000001050042177</a></p>
        </div>
        <div class="box mb-3">
            <p>（13）OPPO推送 SDK</p>
            <p><span>第三方公司名称：</span>广东欢太科技有限公司</p>
            <p><span>共享类型：</span>内嵌SDK</p>
            <p><span>共享信息：</span>唯一设备识别码（IMEI/Android_ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息）、联网状态信息、获取位置信息、获取运行中进程信息、获取应用安装列表；获取设备硬件序列号、获取Android ID、获取 MAC 地址。</p>
            <p><span>使用目的：</span>实现消息推送服务</p>
            <p><span>使用场景：</span>消息推送</p>
            <p><span>共享方式：</span>（外部）接口共享</p>
            <p><span>第三方隐私链接：</span><a target="_blank" href="https://open.oppomobile.com/new/developmentDoc/info?id=10288">https://open.oppomobile.com/new/developmentDoc/info?id=10288</a></p>
        </div>
        <div class="box mb-3">
            <p>（14）vivo推送 SDK</p>
            <p><span>第三方公司名称：</span>维沃移动通信有限公司</p>
            <p><span>共享类型：</span>内嵌SDK</p>
            <p><span>共享信息：</span>唯一设备识别码（IMEI/Android_ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息）、联网状态信息、获取位置信息、获取运行中进程信息、获取应用安装列表；获取设备硬件序列号、获取Android ID、获取 MAC 地址。</p>
            <p><span>使用目的：</span>实现消息推送服务</p>
            <p><span>使用场景：</span>消息推送</p>
            <p><span>共享方式：</span>（外部）接口共享</p>
            <p><span>第三方隐私链接：</span><a target="_blank" href="https://dev.vivo.com.cn/documentCenter/doc/652">https://dev.vivo.com.cn/documentCenter/doc/652</a></p>
        </div>
        <div class="box mb-3">
            <p>（15）创蓝闪验 SDK（chuanglan-sms-operator）</p>
            <p><span>第三方公司名称：</span>上海璟梦信息科技有限公司</p>
            <p><span>共享类型：</span>内嵌SDK</p>
            <p><span>共享信息：</span>获取IP地址、网卡、MAC地址、国际移动设备识别码（IMEI、IMSI）、OAID（替代IMEI）、sim卡信息，并会收集手机机型、系统类型、系统版本、网络环境、网关取号、报错日志；获取设备硬件序列号、获取Android ID、获取 MAC 地址。</p>
            <p><span>使用目的：</span>用于帮助实现用户一键登录行为；提供反欺诈等功能</p>
            <p><span>使用场景：</span>本机号码一键登录</p>
            <p><span>共享方式：</span>（外部）接口共享</p>
            <p><span>第三方隐私链接：</span><a target="_blank" href="https://sdk.253.com/commit-detail/rcc5zd/fd21s8">https://sdk.253.com/commit-detail/rcc5zd/fd21s8</a></p>
        </div>
        <div class="box mb-3">
            <p>（16）腾讯Bugly SDK（com.tencent.bugly）</p>
            <p><span>第三方公司名称：</span>深圳市腾讯计算机系统有限公司</p>
            <p><span>共享类型：</span>内嵌SDK</p>
            <p><span>共享信息：</span>获取IP地址、网卡、MAC地址、国际移动设备识别码（IMEI、IMSI）、OAID（替代IMEI）、sim卡信息，并会收集手机机型、系统类型、系统版本、网络环境、网关取号、报错日志；获取设备硬件序列号、获取Android ID。</p>
            <p><span>使用目的：</span>用于提供崩溃日志上报、热修复、版本更新推送的服务。</p>
            <p><span>使用场景：</span>崩溃日志上报、热修复、版本更新推送</p>
            <p><span>共享方式：</span>（外部）接口共享</p>
            <p><span>第三方隐私链接：</span><a target="_blank" href="https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56">https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56</a></p>
        </div>
        <div class="box mb-3">
            <p>（17）华为联运应用 SDK（Android版）</p>
            <p><span>第三方公司名称：</span>华为软件技术有限公司</p>
            <p><span>共享类型：</span>内嵌SDK</p>
            <p><span>共享信息：</span>唯一设备识别码（IMEI/Android_ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息）、联网状态信息、获取位置信息、获取运行中进程信息、获取应用安装列表。设备信息（设备标识符）、帐号信息（华为帐号ID）、商业公开发布的内容（应用基本信息）、设备信息（国家码、操作系统、产品品牌）、应用信息（内容下载渠道、应用功能设置、应用使用记录）、设备硬件信息（设备类型）；获取设备硬件序列号、获取Android ID、获取 MAC 地址。</p>
            <p><span>使用目的：</span>提供用户华为帐号登录功能与联运支付功能</p>
            <p><span>使用场景：</span>华为帐号登录、联运支付</p>
            <p><span>共享方式：</span>（外部）接口共享</p>
            <p><span>第三方隐私链接：</span><a target="_blank" href="https://developer.huawei.com/consumer/cn/doc/AppGallery-connect-Guides/appgallerykit-app-sdk-security-0000001714810945">https://developer.huawei.com/consumer/cn/doc/AppGallery-connect-Guides/appgallerykit-app-sdk-security-0000001714810945</a></p>
        </div>
        <div class="box mb-3">
            <p>（18）支付宝客户端 SDK</p>
            <p><span>第三方公司名称：</span>支付宝（中国）网络技术有限公司</p>
            <p><span>共享类型：</span>内嵌SDK</p>
            <p><span>共享信息：</span>Android ID、OAID、SSID、BSSID；系统设置、系统属性、设备型号、设备品牌、操作系统；IP 地址、网络类型、运营商信息、Wi-Fi 状态、Wi-Fi 参数、Wi-Fi 列表；开放匿名设备标识符、MAC地址、IMEI信息、传感器、设备硬件序列号。</p>
            <p><span>使用目的：</span>保障用户账户和资金安全以及支付服务的安全稳定运行。履行反洗钱、反恐怖融资、反电信网络诈骗等法定义务。实现网络链路的选择和优化，以提升用户体验。</p>
            <p><span>使用场景：</span>用户使用支付宝账号支付</p>
            <p><span>共享方式：</span>（外部）接口共享</p>
            <p><span>第三方隐私链接：</span><a target="_blank" href="https://opendocs.alipay.com/common/02kiq3">https://opendocs.alipay.com/common/02kiq3</a></p>
        </div>
        <div class="box mb-3">
            <p>（19）微信支付 SDK</p>
            <p><span>第三方公司名称：</span>深圳市腾讯计算机系统有限公司</p>
            <p><span>共享类型：</span>内嵌SDK</p>
            <p><span>共享信息：</span>Android ID、OAID、SSID、BSSID；系统设置、系统属性、设备型号、设备品牌、操作系统；IP 地址、网络类型、运营商信息、Wi-Fi 状态、Wi-Fi 参数、Wi-Fi 列表；开放匿名设备标识符、MAC地址、IMEI信息、传感器、设备硬件序列号。</p>
            <p><span>使用目的：</span>保障用户账户和资金安全以及支付服务的安全稳定运行。履行反洗钱、反恐怖融资、反电信网络诈骗等法定义务。实现网络链路的选择和优化，以提升用户体验。</p>
            <p><span>使用场景：</span>用户使用微信账号支付</p>
            <p><span>共享方式：</span>（外部）接口共享</p>
            <p><span>第三方隐私链接：</span><a target="_blank" href="https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8">https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8</a></p>
        </div>
        <div class="box mb-3">
            <p>（20）华为应用内支付SDK</p>
            <p><span>第三方公司名称：</span>华为软件技术有限公司</p>
            <p><span>共享类型：</span>内嵌SDK</p>
            <p><span>共享信息：</span>唯一设备识别码（IMEI/Android_ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息）、联网状态信息、获取位置信息、获取运行中进程信息、获取应用安装列表。设备信息（设备标识符）、帐号信息（华为帐号ID）、商业公开发布的内容（应用基本信息）、设备信息（国家码、操作系统、产品品牌）、应用信息（内容下载渠道、应用功能设置、应用使用记录）、设备硬件信息（设备类型）；获取设备硬件序列号、获取Android ID、获取 MAC 地址。</p>
            <p><span>使用目的：</span>提供用户华为联运支付功能。</p>
            <p><span>使用场景：</span>用户使用华为联运支付</p>
            <p><span>共享方式：</span>（外部）接口共享</p>
            <p><span>第三方隐私链接：</span><a target="_blank" href="https://developer.huawei.com/consumer/cn/doc/HMSCore-Guides/sdk-data-security-0000001050044906">https://developer.huawei.com/consumer/cn/doc/HMSCore-Guides/sdk-data-security-0000001050044906</a></p>
        </div>
        <div class="box mb-3">
            <p>（21）新浪微博开放平台 SDK</p>
            <p><span>第三方公司名称：</span>北京微梦创科网络技术有限公司</p>
            <p><span>共享类型：</span>内嵌SDK</p>
            <p><span>共享信息：</span>设备基础信息：唯一设备识别码 IMEI、IMSI 信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本、设备IP、获取设备硬件序列号、获取Android ID、获取 MAC 地址</p>
            <p><span>使用目的：</span>提供微博分享功能</p>
            <p><span>使用场景：</span>用户分享内容</p>
            <p><span>共享方式：</span>（外部）接口共享</p>
            <p><span>第三方隐私链接：</span><a target="_blank" href="https://open.weibo.com/wiki/%E5%BC%80%E5%8F%91%E8%80%85%E5%8D%8F%E8%AE%AE#.E9.9A.90.E7.A7.81.E7.9B.B8.E5.85.B3.E6.9D.A1.E6.AC.BE">https://open.weibo.com/wiki/%E5%BC%80%E5%8F%91%E8%80%85%E5%8D%8F%E8%AE%AE#.E9.9A.90.E7.A7.81.E7.9B.B8.E5.85.B3.E6.9D.A1.E6.AC.BE</a></p>
        </div>
        <div class="box mb-3">
            <p>（22）BeiZi SDK</p>
            <p><span>第三方公司名称：</span>上海倍孜网络技术有限公司</p>
            <p><span>共享类型：</span>内嵌SDK</p>
            <p><span>共享信息：</span>唯一设备识别码（IMEI/Android_ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息）、联网状态信息、获取位置信息；无线网SSID名称、WiFi路由器MAC地址（BSSID）、设备的MAC地址；设备标识符（如IMEI、IMSI、ICCID、GAID（仅GMS服务）、MEID、设备序列号build_serial，具体字段因软硬件版本不同而存在差异）；设备标识符（如IDFA，具体字段因软硬件版本不同而存在差异）、获取设备硬件序列号；设备品牌、设备型号、设备时区、设备语言、系统版本、网络类型、UserAgent信息、屏幕高宽、屏幕方向、屏幕DPI信息、系统更新时间、开机时间、磁盘空间、物理内存、运营商、sim卡状态、传感器信息(例如：重力传感器、加速度传感器、方向传感器、陀螺仪、压力传感器、重力传感器、线性加速度传感器)、掠过手势内容、产品交互数据、广告数据(如展示、点击、转化广告数据)；获取运行中进程信息、获取应用安装列表；精确位置信息、粗略位置信息</p>
            <p><span>使用目的：</span>广告投放及监测归因、反作弊、统计分析、减少App崩溃、提供可靠稳定的服务 </p>
            <p><span>使用场景：</span>广告投放</p>
            <p><span>共享方式：</span>（外部）接口共享</p>
            <p><span>第三方隐私链接：</span><a target="_blank" href="http://sdkdoc.beizi.biz/#/zh-cn/guide/UsePrivacy">http://sdkdoc.beizi.biz/#/zh-cn/guide/UsePrivacy</a></p>
        </div>
        <div class="box mb-3">
            <p>（23）七牛 SDK</p>
            <p><span>第三方公司名称：</span>上海七牛信息技术有限公司</p>
            <p><span>共享类型：</span>内嵌SDK</p>
            <p><span>共享信息：</span>设备品牌、型号、操作系统版本、处理器信息、内存使用情况、IP 地址、网络类型及连接信息、读取设备外部存储空间、获取设备硬件序列号、获取 MAC 地址</p>
            <p><span>使用目的：</span>广告投放及监测归因、反作弊、统计分析、减少App崩溃、提供可靠稳定的服务 </p>
            <p><span>使用场景：</span>提供音频文件下载完整性校验、以及用户帐号头像上传的服务</p>
            <p><span>共享方式：</span>（外部）接口共享</p>
            <p><span>第三方隐私链接：</span><a target="_blank" href="https://developer.qiniu.com/pili/8027/sdk-privacy-policy">https://developer.qiniu.com/pili/8027/sdk-privacy-policy</a></p>
        </div>

    </div>
</template>

<script>
export default {
    data(){
        return {

        }
    },
    created(){

    },
    mounted(){

    },
    methods:{

    },
}
</script>

<style lang='scss' scoped>
h2{
    font-size: px2html(16px);
}


.box{
    
    p{
        text-align: left;
        margin-bottom: px2html(5px);
        &:first-child{
            font-weight: bolder;
            font-size: px2html(16px);
        }
        span{
            font-weight: bold;
        }
        a{
            color: rgb(8,124,255);
            text-decoration: underline;
        }
    }

}
</style>